import { createContext, type PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ReviewsStore } from 'pages/reviews/store/reviewsStore'

export const ReviewsContext = createContext<ReviewsStore | null>(null)

export const useReviewsContext = () => {
  const context = useContext(ReviewsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ReviewsContext')

  return context
}

export const ReviewsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new ReviewsStore(entities))

  useEffect(() => {
    void store.init()

    return () => store.dispose()
  }, [])

  return <ReviewsContext.Provider value={store}>{children}</ReviewsContext.Provider>
}
